/* jslint browser: true,  devel: true */
window.msNews.controller("NewsfeedCtrl", [
  "$scope",
  "$state",
  "$stateParams",
  "apiFiles",
  "$q",
  function($scope, $state, $stateParams, apiFiles, $q) {
    console.log("NewsfeedCtrl:init as Newsfeed");
  }
]);



// WEBPACK FOOTER //
// ./src/apps/news/controllers/feed.js